document.addEventListener('DOMContentLoaded', function() {
    const ctaSection = document.querySelector('section.full-width-cta-section');
    if (!ctaSection) {return;}

    let prevSection = ctaSection.previousElementSibling;

    while (prevSection && prevSection.tagName !== 'SECTION') {
        prevSection = prevSection.previousElementSibling;
    }

    if (!prevSection) {return;}

    const prevBgColor = window.getComputedStyle(prevSection).backgroundColor;

    if (prevBgColor === 'rgba(0, 0, 0, 0)' || prevBgColor === 'transparent') {
        const bodyBgColor = window.getComputedStyle(document.body).backgroundColor;
        ctaSection.style.setProperty('--prev-section-bg-color', bodyBgColor);
    } else {
        ctaSection.style.setProperty('--prev-section-bg-color', prevBgColor);
    }
});